var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "span",
      {
        class: {
          "order_status placed_status": true,
          sent_status: _vm.status == "Sent to Restaurant",
          completed_status: _vm.status == "Delivered",
          cancelled_status: _vm.status == "Cancelled",
          eta_status: _vm.status && _vm.status.includes("ETA")
        }
      },
      [_vm._v("\n    " + _vm._s(_vm.status) + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d2aa9b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d2aa9b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ResOrderStatus.vue
// module id = null
// module chunks = 